import type { RaisonDeRefus } from "./contract";
import type { RefusSauvegarde } from "./moteur/sauvegarde";

/**
 * Les phrases que l'appli dit au lecteur quand quelque chose ne passe pas. Regroupees ici pour
 * se relire d'un coup : elles doivent dire ce qui se passe et quoi faire, sans jargon.
 */

export interface MessageDeRefus {
  titre: string;
  texte: string;
}

/** `sansPartie` : le lecteur n'a encore rien joue, il est donc en page 1. */
export function messageDeRefus(
  raison: RaisonDeRefus,
  page: number,
  sansPartie: boolean,
): MessageDeRefus {
  switch (raison) {
    case "code-inconnu":
      return {
        titre: "Code inconnu",
        texte:
          "Ce code n'existe pas dans ce livre. Vérifiez les trois caractères écrits sous le QR code.",
      };
    case "pas-sur-cette-page":
      return sansPartie
        ? {
            titre: "L'enquête commence page 1",
            texte:
              "Ce choix n'est pas sur la page 1. Commencez par lire la page 1, puis scannez l'un de ses choix.",
          }
        : {
            titre: `Ce choix n'est pas sur la page ${page}`,
            texte: `Vous en êtes à la page ${page}. Lisez-la, puis scannez l'un des choix qu'elle propose.`,
          };
    case "partie-finie":
      return {
        titre: "Votre partie est finie",
        texte: `Elle s'est terminée page ${page}. Pour rejouer, recommencez une partie.`,
      };
    case "pas-un-code":
      return {
        titre: "Ce QR code ne vient pas du livre",
        texte: "Visez le QR code imprimé sous le choix que vous voulez faire.",
      };
    case "etat-perime":
      return {
        titre: "Partie illisible",
        texte:
          "Votre partie ne correspond plus à cette version du livre. Recommencez, ou reprenez avec votre code de sauvegarde.",
      };
    default:
      // enigme-attendue, pas-une-enigme, aucune-suite : le magasin ne les laisse pas arriver
      // jusqu'ici ; on reste poli si c'est le cas.
      return {
        titre: "Ce choix ne passe pas",
        texte: `Revenez à la page ${page} et faites un autre choix.`,
      };
  }
}

export function messageDeReprise(refus: RefusSauvegarde): string {
  switch (refus) {
    case "longueur":
      return "Un code de sauvegarde a 9 caractères : quatre, quatre, puis un.";
    case "caractere":
      return "Ce code contient un caractère qu'un code de sauvegarde n'utilise jamais.";
    case "controle":
      return "Ce code contient une faute de frappe : vérifiez chaque caractère.";
    default:
      return "Ce code ne correspond pas à ce livre, ou à une autre version de ce livre.";
  }
}
